export default (parameters) => {
  return {
    baseUrl: import.meta.env.VITE_LIFESTYLE_API_URL_PROD,
    mmrsApiUrl: import.meta.env.VITE_MAP_TILES_URL_CDN_PROD,
    tempestRestApiUrl: import.meta.env.VITE_TEMPEST_REST_API_URL_PROD,
    tempestWSApiUrl: import.meta.env.VITE_TEMPEST_WEBSOCKET_API_URL_PROD,
    apiKey: null,
  }
}
